import { checkboxAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { column } from './radio';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {
    alignItems: 'top',
  },
  control: {
    marginTop: 1,
    _checked: {
      bg: 'tmtBlue',
      borderColor: 'tmtBlue',
      _hover: {
        bg: 'blue.700',
        borderColor: 'blue.700',
      },
    },
    _dark: {
      _checked: {
        bg: 'tmtGold',
        borderColor: 'tmtGold',
        _hover: {
          bg: 'orange.400',
          borderColor: 'orange.400',
        },
      },
    },
  },
});

const itemCheckbox = definePartsStyle({
  container: {
    border: '1px',
    bg: 'gray.50',
    w: '100%',
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    gap: 3,
    pr: 3,
    transitionProperty: 'var(--chakra-transition-property-common)',
    transitionDuration: 'var(--chakra-transition-duration-normal)',
    _dark: {
      bg: 'gray.800',
    },
    _hover: {
      borderColor: 'tmtBlue',
      _dark: { borderColor: 'tmtGold' },
    },
    _checked: {
      bg: '#fff',
      outline: '3px solid',
      outlineColor: 'tmtBlue',
      _dark: {
        bg: 'tmtBlack',
        outlineColor: 'tmtGold',
      },
    },
  },
  control: {
    bg: '#fff',
    m: 0,
    w: '20px',
    h: '20px',
    borderRadius: '10px',
    border: '1px',
    _dark: {
      bg: 'tmtBlack',
    },
  },
  label: {
    w: '100%',
    display: 'flex',
    gap: 3,
    alignItems: 'center',
    m: 0,
  },
});

export default defineMultiStyleConfig({
  baseStyle,
  variants: {
    column,
    itemCheckbox,
  },
});
